module.exports = __webpack_public_path__ + "static/favicon.e61086d1.ico";


//////////////////
// WEBPACK FOOTER
// ./src/components/favicon/favicon.ico
// module id = 108
// module chunks = 915738553496 35783957827783